<template>
  <div class="container flip-clock" v-show="show">
    <template v-for="(data, idx) in timeData" :keys="idx">
      <span v-if="!isNaN(data.current)" v-bind:key="data.label" class="flip-clock__piece" :id="data.elementId" v-show="data.show">
        <span class="flip-clock__card flip-card" :style="{fontSize: `${windowWidth()/resolution/4}px`}">
          <b class="flip-card__top">{{ data.current | oneDigits }}</b>
          <b class="flip-card__bottom" v-bind:data-value="data.current | oneDigits"></b>
          <b class="flip-card__back" v-bind:data-value="data.previous | oneDigits"></b>
          <b class="flip-card__back-bottom" v-bind:data-value="data.previous | oneDigits"></b>
        </span>
        <span v-if="!showPercie" class="flip-clock__slot">{{ data.label }}</span>
      </span>
      <span v-else v-bind:key="data.label" :id="data.elementId" style="vertical-align:bottom;">
        <v-icon x-small
            style="color:#222;">
          mdi-checkbox-blank-circle
        </v-icon>
      </span>
    </template>
    <span v-if="showPercie" class="flip-clock__slot">Percies</span>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
const moment = require('moment-timezone')
const axios = require('axios')

export default {
  name: 'flipCountdown',
  props: {
    deadline: {
      type: String,
    },
    stop: {
      type: Boolean,
    },
    resolution: {
      type: Number,
      required: false,
      default: 8,
    },
    gender: {
      type: String,
      required: false,
      default: 'm',
    },
    showPercie: {
      type: Boolean,
      required: false,
      default: false,
    },
    showYears: {
      type: Boolean,
      required: false,
      default: true,
    },
    showMonths: {
      type: Boolean,
      required: false,
      default: true,
    },
    showDays: {
      type: Boolean,
      required: false,
      default: true,
    },
    showHours: {
      type: Boolean,
      required: false,
      default: true,
    },
    showMinutes: {
      type: Boolean,
      required: false,
      default: true,
    },
    showSeconds: {
      type: Boolean,
      required: false,
      default: true,
    },
    labels: {
      type: Object,
      required: false,
      default: function() {
        return {
          years: 'Years',
          months: 'Months',
          days: 'Days',
          hours: 'Hours',
          minutes: 'Minutes',
          seconds: 'Seconds',
        };
      },
    },
  },
  data() {
    const uuid = uuidv4();
    return {
      now: Math.trunc(new Date().getTime() / 1000),
      date: null,
      interval: null,
      diff: 0,
      show: true,
      percie: 0,
      timeData: [
        {
          current: 0,
          previous: 0,
          label: this.labels.years,
          elementId: 'flip-card-years-' + uuid,
          show: this.showYears,
        },
        {
          current: 0,
          previous: 0,
          label: this.labels.months,
          elementId: 'flip-card-months-' + uuid,
          show: this.showMonths,
        },
        {
          current: 0,
          previous: 0,
          label: this.labels.days,
          elementId: 'flip-card-days-' + uuid,
          show: this.showDays,
        },
        {
          current: 0,
          previous: 0,
          label: this.labels.hours,
          elementId: 'flip-card-hours-' + uuid,
          show: this.showHours,
        },
        {
          current: 0,
          previous: 0,
          label: this.labels.minutes,
          elementId: 'flip-card-minutes-' + uuid,
          show: this.showMinutes,
        },
        {
          current: 0,
          previous: 0,
          label: this.labels.seconds,
          elementId: 'flip-card-seconds-' + uuid,
          show: this.showSeconds,
        },
      ],
    };
  },
  created() {
    if (this.showPercie) {
      this.timeData = []
      const uuid = uuidv4();
      let loopCount = 0
      for (let i of this.percies) {
        this.timeData.push(
          {
            current: i,
            previous: 0,
            label: `flip-card-${loopCount}-${uuid}`,
            elementId: `flip-card-${loopCount}-${uuid}`,
            show: true,
          }
        )
        loopCount++
      }
    }

    if (!this.deadline) {
      throw new Error("Missing props 'deadline'");
    }
    const endTime = this.deadline;
    this.date = Math.trunc(Date.parse(endTime.replace(/-/g, '/')) / 1000);
    if (!this.date) {
      throw new Error("Invalid props value, correct the 'deadline'");
    }
    this.interval = setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000);
    }, 1000);
  },
  mounted() {
    if (this.diff !== 0) {
      this.show = true;
    }
  },
  computed: {
    percies() {
      return this.percie.toFixed(this.resolution).toString().split('').map(x => parseInt(x))
    },
    seconds() {
      return Math.trunc(this.diff) % 60;
    },
    minutes() {
      return Math.trunc(this.diff / 60) % 60;
    },
    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24;
    },
    days() {
      return Math.trunc(this.diff / 60 / 60 / 24);
    },
    left() {

      let death = moment(this.deadline)
      const years = death.diff(moment(), 'years')
      death.subtract(years, 'years')
      const months = death.diff(moment(), 'months')
      death.subtract(months, 'months')
      const days = death.diff(moment(), 'days')
      death.subtract(days, 'days')
      const hours = death.diff(moment(), 'hours')
      death.subtract(hours, 'hours')
      const minutes = death.diff(moment(), 'minutes')
      death.subtract(minutes, 'minutes')
      const seconds = death.diff(moment(), 'seconds')
      death.subtract(seconds, 'seconds')
      return {
        years,
        months,
        days,
        hours,
        minutes,
        seconds,
        diff: this.diff
      }
    }
  },
  watch: {
    deadline: function(newVal, oldVal) {
      const endTime = this.deadline;
      this.date = Math.trunc(Date.parse(endTime.replace(/-/g, '/')) / 1000);
      if (!this.date) {
        throw new Error("Invalid props value, correct the 'deadline'");
      }
    },
    now(value) {
      this.diff = !this.showPercie ? this.date - this.now : 1
      if (this.diff <= 0 || this.stop) {
        this.diff = 0;
        this.updateTime(3, 0);
      } else {
        this.percie = this.myRemainingLifeInPercents()
        this.updateAllCards();
      }
    },
    diff(value) {
      if (value === 0) {
        this.$emit('timeElapsed');
        this.updateAllCards();
      }
    },
  },
  filters: {
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString();
      }
      return value.toString();
    },
    oneDigits(value) {
      return value.toString();
    },
  },
  methods: {
    windowWidth() {
      return window.innerWidth
    },
    myRemainingLifeInPercents() {
      let manMaxAge = 78.6
      let womanMaxAge = 83.4

      const birthday = moment(this.deadline)
      const timeDiff = moment().diff(birthday)
      const seconds = timeDiff / 1000

      let maxSeconds
      if (this.gender === 'm') {
          maxSeconds = manMaxAge * 365 * 24 * 60 * 60
      } else {
          maxSeconds = womanMaxAge * 365 * 24 * 60 * 60
      }

      const percentAge = 100 / maxSeconds * seconds

      //console.log('Midlife at', birthday.clone().add(50 * maxSeconds / 100, 's').format())
      //console.log('Death at', birthday.clone().add(maxSeconds, 's').format())

      return percentAge
    },
    updateAllCards() {
      if (this.showPercie) {
        let loopCount = 0
        for (let i of this.percies) {
          this.updateTime(loopCount, i);
          loopCount++
        }
      } else {
        /*this.updateTime(0, this.days);
        this.updateTime(1, this.hours);
        this.updateTime(2, this.minutes);
        this.updateTime(3, this.seconds);
        */
        const left = this.left
        this.updateTime(0, left.years);
        this.updateTime(1, left.months);
        this.updateTime(2, left.days);
        this.updateTime(3, left.hours);
        this.updateTime(4, left.minutes);
        this.updateTime(5, left.seconds);
      }
    },
    updateTime(idx, newValue) {
      if (idx >= this.timeData.length || newValue === undefined) {
        return;
      }
      if (window['requestAnimationFrame']) {
        this.frame = requestAnimationFrame(this.updateTime.bind(this));
      }
      const d = this.timeData[idx];
      const val = newValue < 0 ? 0 : newValue;
      const el = document.querySelector(`#${d.elementId}`);
      if (val !== d.current) {
        d.previous = d.current;
        d.current = val;
        if (el) {
          el.classList.remove('flip');
          void el.offsetWidth;
          el.classList.add('flip');
        }
        if (idx === 0) {
          const els = el.querySelectorAll('span b');
          if (els) {
            for (let e of els) {
              const cls = e.classList[0];
              if (newValue / 1000 >= 1) {
                if (!cls.includes('-4digits')) {
                  const newCls = cls + '-4digits';
                  e.classList.add(newCls);
                  e.classList.remove(cls);
                }
              } else {
                if (cls.includes('-4digits')) {
                  const newCls = cls.replace('-4digits', '');
                  e.classList.add(newCls);
                  e.classList.remove(cls);
                }
              }
            }
          }
        }
      }
    },
  },
  beforeDestroy() {
    if (window['cancelAnimationFrame']) {
      cancelAnimationFrame(this.frame);
    }
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped lang="less">
.flip-clock {
  text-align: center;
  perspective: 600px;
  margin: 0 auto;
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
}
.flip-clock__piece {
  display: inline-block;
  margin: 0 0.2vw;
  @media (min-width: 1000px) {
    margin: 0 5px;
  }
}
.flip-clock__slot {
  font-size: 1rem;
  line-height: 1.5;
  display: block;
}
@halfHeight: 0.72em;
@borderRadius: 0.15em;
.flip-card {
  display: block;
  position: relative;
  padding-bottom: @halfHeight;
  font-size: 2.25rem;
  line-height: 0.95;
}
@media (min-width: 1000px) {
  .flip-clock__slot {
    font-size: 1.2rem;
  }
  .flip-card {
    font-size: 3rem;
  }
}
.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  display: block;
  height: @halfHeight;
  color: #cca900;
  background: #222;
  padding: 0.23em 0.15em 0.4em;
  border-radius: @borderRadius @borderRadius 0 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform-style: preserve-3d;
  width: 2.1em;
  height: @halfHeight;
}
.flip-card__top-4digits,
.flip-card__bottom-4digits,
.flip-card__back-bottom-4digits,
.flip-card__back-4digits::before,
.flip-card__back-4digits::after {
  display: block;
  height: @halfHeight;
  color: #cca900;
  background: #222;
  padding: 0.23em 0.15em 0.4em;
  border-radius: @borderRadius @borderRadius 0 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform-style: preserve-3d;
  width: 2.65em;
  height: @halfHeight;
}
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__bottom-4digits,
.flip-card__back-bottom-4digits {
  color: #ffdc00;
  position: absolute;
  top: 50%;
  left: 0;
  border-top: solid 1px #000;
  background: #393939;
  border-radius: 0 0 @borderRadius @borderRadius;
  pointer-events: none;
  overflow: hidden;
  z-index: 2;
}
.flip-card__back-bottom,
.flip-card__back-bottom-4digits {
  z-index: 1;
}
.flip-card__bottom::after,
.flip-card__back-bottom::after,
.flip-card__bottom-4digits::after,
.flip-card__back-bottom-4digits::after {
  display: block;
  margin-top: -@halfHeight;
}
.flip-card__back::before,
.flip-card__bottom::after,
.flip-card__back-bottom::after,
.flip-card__back-4digits::before,
.flip-card__bottom-4digits::after,
.flip-card__back-bottom-4digits::after {
  content: attr(data-value);
}
.flip-card__back,
.flip-card__back-4digits {
  position: absolute;
  top: 0;
  height: 100%;
  left: 0%;
  pointer-events: none;
}
.flip-card__back::before,
.flip-card__back-4digits::before {
  position: relative;
  overflow: hidden;
  z-index: -1;
}
.flip .flip-card__back::before,
.flip .flip-card__back-4digits::before {
  z-index: 1;
  animation: flipTop 0.3s cubic-bezier(0.37, 0.01, 0.94, 0.35);
  animation-fill-mode: both;
  transform-origin: center bottom;
}
.flip .flip-card__bottom,
.flip .flip-card__bottom-4digits {
  transform-origin: center top;
  animation-fill-mode: both;
  animation: flipBottom 0.6s cubic-bezier(0.15, 0.45, 0.28, 1);
}
@keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 2;
  }
  0%,
  99% {
    opacity: 1;
  }
  100% {
    transform: rotateX(-90deg);
    opacity: 0;
  }
}
@keyframes flipBottom {
  0%,
  50% {
    z-index: -1;
    transform: rotateX(90deg);
    opacity: 0;
  }
  51% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: rotateX(0deg);
    z-index: 5;
  }
}
</style>